import { Component, OnInit,OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Validators, FormBuilder, FormGroup  } from '@angular/forms';

import { MensajesContactoService } from './../services/mensajes-contacto.service';
import { GooglePlaceDirective } from "ngx-google-places-autocomplete";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit, OnDestroy {

  seccion:string;
  subRoute;
  placesSearchOptions:any = {
    types: [],
    componentRestrictions: { country: 'MX' }
  }
  address:any;

  mostrarGeneral:boolean = false;
  mostrarDist:boolean = false;
  mostrarCliente:boolean = false;

  private formMsjGeneral : FormGroup;
  private formMsjCliente : FormGroup;
  private formMsjDist : FormGroup;

  @ViewChild("placesRef") placesRef : GooglePlaceDirective;

  constructor(private route: ActivatedRoute,
    private router:Router, private formBuilder:FormBuilder,
    private msjsService:MensajesContactoService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() { 
      this.subRoute = this.route.params.subscribe(params => {
        this.seccion = params['seccion'];

        if(this.seccion==='distribuidor'){
          this.mostrarDist = true;
          this.mostrarCliente = false;
          this.mostrarGeneral = false;
        }

        if(this.seccion==='cliente'){
          this.mostrarCliente = true;
          this.mostrarDist = false;
          this.mostrarGeneral = false;
        }

        if(this.seccion==='general'){
          this.mostrarGeneral = true;
          this.mostrarCliente = false;
          this.mostrarDist = false;
        }

      });

      this.formMsjGeneral = this.formBuilder.group({
        completeName: ['', Validators.required],
        email: ['', Validators.required],
        phoneNumber: [''],
        comments: ['', Validators.required]
      });

      this.formMsjCliente = this.formBuilder.group({
        name: ['', Validators.required],
        lastName: ['', Validators.required],
        secondLastName: ['', Validators.required],
        address: [''],
        school: ['', Validators.required],
        email: ['', Validators.required],
        phoneNumber: [''],
        comments: ['', Validators.required]
      });

      this.formMsjDist = this.formBuilder.group({
        name: ['',Validators.required],
        lastName: ['',Validators.required],
        secondLastName: ['',Validators.required],
        address: [''],
        phoneNumber: ['',Validators.required],
        cellPhoneNumber: [''],
        email: ['', Validators.required],
        comments: ['',Validators.required]
      });
  }

  ngOnDestroy(){
    this.subRoute.unsubscribe();
  }

  public handleAddressChange(address: any) {
    // Do some stuff
    this.address = address.formatted_address
    console.log(this.address);
  }

  enviarMsj(userType:string){
    let data:any = {};

    switch(userType){
      case 'general':

        if(this.formMsjGeneral.valid){

          this.spinner.show();

          data = {
            completeName: this.formMsjGeneral.get('completeName').value,
            email: this.formMsjGeneral.get('email').value,
            phoneNumber: this.formMsjGeneral.get('phoneNumber').value,
            comments: this.formMsjGeneral.get('comments').value,
            userType: userType
          };
          
          this.msjsService.enviarMsj(data, userType).then((res)=>{
            console.log(res);
            this.spinner.hide();
            alert('Mensaje enviado correctamente');
            this.router.navigateByUrl('/');
          }).catch((error)=>{
            alert('Error al enviar');
            this.spinner.hide();
            console.log(error);
          });

        }else{
          alert('Favor de llenar la información');
        }

        break;
      case 'maestro':

        if(this.formMsjCliente.valid){
          this.spinner.show();

          data = {
            name: this.formMsjCliente.get('name').value,
            lastName: this.formMsjCliente.get('lastName').value,
            secondLastName:this.formMsjCliente.get('secondLastName').value,
            address: this.address,
            school: this.formMsjCliente.get('school').value,
            email: this.formMsjCliente.get('email').value,
            phoneNumber: this.formMsjCliente.get('phoneNumber').value,
            comments: this.formMsjCliente.get('comments').value,
            userType: userType
          };
          
          this.msjsService.enviarMsj(data, userType).then((res)=>{
            console.log(res);
            this.spinner.hide();
            alert('Mensaje enviado correctamente');
            this.router.navigateByUrl('/');
          }).catch((error)=>{
            alert('Error al enviar');
            this.spinner.hide();
            console.log(error);
          });
        }else{
          alert('Favor de llenar la información');
        }

        break;
      case 'distribuidor':

        if(this.formMsjDist.valid){
          this.spinner.show();

          data = {
            name: this.formMsjDist.get('name').value,
            lastName: this.formMsjDist.get('lastName').value,
            secondLastName:this.formMsjDist.get('secondLastName').value,
            address: this.address,
            email: this.formMsjDist.get('email').value,
            phoneNumber: this.formMsjDist.get('phoneNumber').value,
            cellPhoneNumber: this.formMsjDist.get('cellPhoneNumber').value,
            comments: this.formMsjDist.get('comments').value,
            userType: userType
          };
          
          this.msjsService.enviarMsj(data, userType).then((res)=>{
            console.log(res);
            this.spinner.hide();
            alert('Mensaje enviado correctamente');
            this.router.navigateByUrl('/');
          }).catch((error)=>{
            alert('Error al enviar');
            this.spinner.hide();
            console.log(error);
          });
        }else{
          alert('Favor de llenar la información');
        }

        break;
    }
  }

}



// WEBPACK FOOTER //
// /Users/lgh/Documents/apps/editorial/src/app/contacto/contacto.component.ts